import Vue from 'vue'

// User login
const login = credentials => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/login',
			auth: credentials
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get list of shops
const getShops = () => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/shop/list',
			data: {
				limit: 30,
				status: true
			}
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

const brandAdjustPrice = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/price-adjustment/create',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

const brandAdjustPriceUpdate = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/price-adjustment/edit',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

const brandAdjustPriceList = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/price-adjustment/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get list of rewards
const getRewards = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member/reward/history/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get list of rewards
const getRewardDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member/reward/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get list of members
const getMembers = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get list of member histories
const getMemberHistory = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/member-history/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get list of brands
const getBrand = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/brand/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Post data to API
const submit = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/promotion/group/create',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get products
const getProducts = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get products
const getProductDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				position: 'top-end',
				icon: 'error',
				title: err.response.data.message,
				showConfirmButton: false,
				timer: 1000
			})
		})
}

// Get products
const checkProducts = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get products
const getProductAdvanced = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/list-advance',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get PIs
const getPIs = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-invoice/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get PO Details
const getPoDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-order/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get PO Details
const getMultiPo = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-order/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get PO Details
const getPiItemDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/purchase-invoice-item/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// File Upload
const fileUpload = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/file/upload',
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			data,
			transformRequest: [
				data => {
					const formData = Vue.prototype.$obj2FormData(data)
					return formData
				}
			]
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Import Shop Products
const importShopProducts = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/shop-product/import',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Import Shop Products
const importProduct = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/import',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Sales
const getSales = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/report/sales/order',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get products
const getHistory = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/promotion-history/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get orders
const getOrders = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/order/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get order details
const getOrderDetails = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/order/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get list of promotions
const getPromotionList = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/promotion/group/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get order details
const getPromotionDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/promotion/group/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get top 50 products
const getTopProducts = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/report/sales/order-items/product',
			data
		})
		.catch(err => {
			console.log(err)
			// Vue.prototype.$swal.fire({
			// 	icon: 'error',
			// 	title: 'Error...',
			// 	text: err.response.data.message
			// })
		})
}

// Get top 50 products
const getTopBrands = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/report/sales/order-items/brand',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get list of product returns
const getProductReturns = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/return-product/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Return Details
const getReturnDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/return-product/detail',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Product Transfer
const getProductTransfers = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/shop-product-transfer/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Direct Purchase List
const getDirectPurchase = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/direct-purchase/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Direct Purchase Detail
const getDirectPurchaseDetail = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/direct-purchase-item/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Shop Product
const shopProduct = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/shop-product/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Chemicals
const getChemicals = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/chemical/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Add Chemical
const addChemical = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/chemical/create',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Shop Product
const addShopProduct = ({ data }) => {
	return Vue.prototype.$axios({
		method: 'post',
		url: '/bd/shop-product/create',
		data
	})
	// .catch(err => {
	// 	// Vue.prototype.$swal.fire({
	// 	// 	icon: 'error',
	// 	// 	title: 'Error...',
	// 	// 	text: err.response.data.message
	// 	// })
	// 	//
	// })
}

// Get Sync Changes
const syncChanges = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/sync-changes/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get order item report/sold quantity
const orderItemReport = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/report/sales/order-items/product',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get order item items list
const orderItemList = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/order-items/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Update Products
const productUpdate = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'patch',
			url: '/bd/product/update',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Clean sync log for disabled shops
const cleanSyncChanges = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/sync-changes/clean',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Update Products
const adjustStock = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'patch',
			url: '/bd/shop-product/update',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Warehouse List
const getWarehouse = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Warehouse Products
const getWarehouseProducts = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse-product/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Import Warehouse Products
const createWarehouseProduct = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse-product/create',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Adjust stock
const updateWarehouseProduct = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'patch',
			url: '/bd/warehouse-product/update',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Shop Product History
const shopProductHistory = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/shop-product-history/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Product History
const productHistory = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product-history/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Product History
const getShopProductTransfer = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/shop-product/transfer/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get Product History
const getReturnProductItems = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/return-product/items/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get stock transfer
const getProductTransfer = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/warehouse/product/transfer/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Delete Order
const orderDelete = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/order/delete',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Delete Products
const productDelete = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/product/delete',
			data
		})
		.catch(err => {
			// Vue.prototype.$swal.fire({
			// 	icon: 'error',
			// 	title: 'Error...',
			// 	text: err.response.data.message
			// })
			console.log(err)
		})
}

// Get Promotions
const getPromotions = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/promotion/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get mismatch shop products
const getShopProductMismatch = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/shop-product-mismatch/list',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Get order item sales export
const salesExport = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/order-items/sales/export',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Export orders
const orderExport = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/order-items/order/export',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

// Export unsold products
const exportUnsoldProducts = ({ data }) => {
	return Vue.prototype
		.$axios({
			method: 'post',
			url: '/bd/shop-product/export/unsold',
			data
		})
		.catch(err => {
			Vue.prototype.$swal.fire({
				icon: 'error',
				title: 'Error...',
				text: err.response.data.message
			})
		})
}

export default {
	login: login,
	brandAdjustPrice: brandAdjustPrice,
	brandAdjustPriceList: brandAdjustPriceList,
	brandAdjustPriceUpdate: brandAdjustPriceUpdate,
	getShops: getShops,
	getBrand: getBrand,
	getRewards: getRewards,
	getRewardDetail: getRewardDetail,
	getChemicals: getChemicals,
	addChemical: addChemical,
	submit: submit,
	getProducts: getProducts,
	getProductDetail: getProductDetail,
	getPIs: getPIs,
	getPoDetail: getPoDetail,
	getMultiPo: getMultiPo,
	getPiItemDetail: getPiItemDetail,
	fileUpload: fileUpload,
	importShopProducts: importShopProducts,
	importProduct: importProduct,
	getSales: getSales,
	getHistory: getHistory,
	getOrders: getOrders,
	getProductAdvanced: getProductAdvanced,
	checkProducts: checkProducts,
	getOrderDetails: getOrderDetails,
	getPromotionList: getPromotionList,
	getPromotionDetail: getPromotionDetail,
	getTopProducts: getTopProducts,
	getTopBrands: getTopBrands,
	getProductReturns: getProductReturns,
	getReturnDetail: getReturnDetail,
	getProductTransfers: getProductTransfers,
	getDirectPurchase: getDirectPurchase,
	getDirectPurchaseDetail: getDirectPurchaseDetail,
	shopProduct: shopProduct,
	addShopProduct: addShopProduct,
	syncChanges: syncChanges,
	orderItemReport: orderItemReport,
	orderItemList: orderItemList,
	productUpdate: productUpdate,
	cleanSyncChanges: cleanSyncChanges,
	adjustStock: adjustStock,
	getWarehouse: getWarehouse,
	getWarehouseProducts: getWarehouseProducts,
	createWarehouseProduct: createWarehouseProduct,
	updateWarehouseProduct: updateWarehouseProduct,
	shopProductHistory: shopProductHistory,
	productHistory: productHistory,
	getShopProductTransfer: getShopProductTransfer,
	getReturnProductItems: getReturnProductItems,
	getProductTransfer: getProductTransfer,
	getPromotions,
	getShopProductMismatch,
	getMembers,
	getMemberHistory,
	orderDelete,
	productDelete,
	salesExport,
	orderExport,
	exportUnsoldProducts
}
